module.exports = __webpack_public_path__ + "img/20190612_132334_027.9bf1d2dd.jpg";